<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm8 offset-sm2 pt-5>

        <v-alert :value="true" v-if="error != null" type="error">{{ error.message }}</v-alert>
        <v-alert :value="true" v-if="success != null" type="success">{{ success.message }}</v-alert>

        <v-layout justify-center column>
          <template v-if="ready">
            <v-form ref="form" v-model="valid" lazy-validation @submit="updateUser">

              <h2 class="heading-2 align-left">Contact Permission</h2>

              <v-layout row>
                <v-flex xs12 pb-0>
                  <strong>I want to hear about everything BRFC has to offer</strong>
                  <v-radio-group v-model="clubOptIn" :rules="toggleRules" row>
                    <v-radio label="Yes" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                  <p>Selecting this option will automatically apply all of the marketing preferences listed below.</p>
                </v-flex>
              </v-layout>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <v-flex xs12 sm3>
                    <v-btn dark @click="showClubPrefs = !showClubPrefs">Manage</v-btn>
                  </v-flex>
                </v-flex>
              </v-layout>

              <div v-if="showClubPrefs === true" class="club-prefs" required>
                <v-layout row>
                  <v-flex xs12 pb-0>
                    <strong>Club News & Updates</strong>
                    <v-radio-group v-model="clubPrefNews" row>
                      <v-radio label="Yes" :value="true"></v-radio>
                      <v-radio label="No" :value="false"></v-radio>
                    </v-radio-group>
                    <p>General club communications including signings, fixture news, content.</p>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs12 pb-0>
                    <strong>Ticketing & Matchday Information</strong>
                    <v-radio-group v-model="clubPrefTickets" row>
                      <v-radio label="Yes" :value="true"></v-radio>
                      <v-radio label="No" :value="false"></v-radio>
                    </v-radio-group>
                    <p>Ticket sales, match pushes, hospitality information and matchday updates.</p>
                  </v-flex>
                </v-layout>

                <v-layout row>
                  <v-flex xs12 pb-0>
                    <strong>Retail & Merchandise Offers </strong>
                    <v-radio-group v-model="clubPrefRetail" row>
                      <v-radio label="Yes" :value="true"></v-radio>
                      <v-radio label="No" :value="false"></v-radio>
                    </v-radio-group>
                    <p>Product launches, offers and retail campaigns.</p>
                  </v-flex>
                </v-layout>
              </div>

              <div v-if="configValues.communitySchemeMarketingEnabled === true">
                <h2 class="heading-3 align-left">{{ configValues.communityScheme.name }} News</h2>
                <div class="body-copy">
                  <p>Keep me updated by email with the latest news from {{ configValues.communityScheme.name }}
                    including
                    fundraising events.</p>
                </div>
                <v-layout row class="border-bottom">
                  <v-flex xs12>
                    <v-switch :label="`Email`" v-model="foundationEmail"></v-switch>
                  </v-flex>
                </v-layout>
              </div>
              <v-layout row>
                <v-flex xs12 pb-0>
                  <strong>Official Partners & Sponsors (Third Party) </strong>
                  <v-radio-group v-model="partnerOptIn" row :rules="toggleRules" required>
                    <v-radio label="Yes" :value="true"></v-radio>
                    <v-radio label="No" :value="false"></v-radio>
                  </v-radio-group>
                  <p>Partner news, offers and competitions, EFL contractual sends.</p>
                </v-flex>
              </v-layout>

              <v-layout row>
                <v-flex xs12 pb-0>
                  <strong>Channels </strong>
                  <p>Please select how you would like to hear from us.</p>
                  <v-switch :label="`Email`" v-model="emailOptIn"></v-switch>
                  <v-switch :label="`Direct Mail`" v-model="directmailOptIn"></v-switch>
                  <v-switch :label="`SMS`" v-model="smsOptIn"></v-switch>

                </v-flex>
              </v-layout>

              <div class="body-copy">
                <p><a :href="configStrings.clubPrivacyPolicyLink" target="_blank">Click here</a> to see our current list
                  of Partners / Sponsors. Our Partners change regularly, so we update this list at least once every
                  season.</p>
              </div>
              <v-layout row align-center mx-1 mt-5>
                <v-spacer />
                <button type="submit" class="button" :disabled="!valid || !ready">Update</button>
              </v-layout>


            </v-form>
          </template>

          <template v-else>
            <div class="text-xs-center">
              <v-progress-circular :size="50" color="accent" indeterminate></v-progress-circular>
            </div>
          </template>
        </v-layout>

      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from 'axios'
export default {
  name: 'UserProfileContactPrefs',
  data() {

    return {
      ready: false,
      valid: true,
      ssoid: '',
      clubOptIn: null, // used to toggle all preferences on/off
      clubAnyPrefsOptIn: null, //used to detect if any club prefs are selected
      allowReaction: false,
      showClubPrefs: true,
      clubPrefTickets: null,
      clubPrefNews: null,
      clubPrefRetail: null,
      partnerOptIn: null,
      emailOptIn: null,
      directmailOptIn: null,
      smsOptIn: null,
      foundationEmail: false,
      toggleRules: [
        v => (v === true || v === false) || 'You must select an option to continue'
      ],
      error: null,
      success: null,
      loading: false
    }
  },
  created() {
    var vm = this
    // load this user's latest information
    this.$getCurrentUserAttributes().subscribe((userData) => {

      vm.getExternalContactPreferences(vm.ssoid)
        .then(function (response) {

          if (response === null) {
            // if the function didn't pass back any preferences
            // Map existing preferences to new structure
            vm.clubPrefNews = ((userData['custom:club_pref_news'] == "true") ? true : false)
            vm.clubPrefTickets = ((userData['custom:club_pref_tickets'] == "true") ? true : false)
            vm.clubPrefRetail = ((userData['custom:club_pref_retail'] == "true") ? true : false)

            if (vm.clubPrefNews && vm.clubPrefTickets && vm.clubPrefRetail) {
              vm.clubOptIn = true
            } else {
              vm.clubOptIn = false
            }

            // Determine Partner Opt In
            if (userData['custom:partner_email'] == "true" || userData['custom:partner_sms'] == "true" || userData['custom:partner_direct'] == "true") {
              vm.partnerOptIn = true
            } else {
              vm.partnerOptIn = false
            }

            // Determine Channel Opt Ins (Aggregated)
            // If they are opted into ANY channel for club OR partner, we assume they want that channel enabled globally
            vm.emailOptIn = (userData['custom:club_email'] == "true" || userData['custom:partner_email'] == "true")
            vm.smsOptIn = (userData['custom:club_sms'] == "true" || userData['custom:partner_sms'] == "true")
            vm.directmailOptIn = (userData['custom:club_direct'] == "true" || userData['custom:partner_direct'] == "true")

            console.log("emailOptIn", vm.emailOptIn)
            console.log("smsOptIn", vm.smsOptIn)
            console.log("directmailOptIn", vm.directmailOptIn)

            // Foundation
            vm.foundationEmail = ((userData['custom:foundation_email'] == "true") ? true : false)

          } else {
            // if we did get preferences (set them)

            //TODO: set local preferences to values from external system'
          }

          // tell the app that we've finished loading

          vm.ready = true
        })
    })
  },
  watch: {
    clubOptIn: function (val, oldVal) {
      if (oldVal !== null) {

        if (val === true) {
          this.clubPrefNews = true
          this.clubPrefTickets = true
          this.clubPrefRetail = true
          this.enableChannels() // This whould be removed if the club wish to not auto opt-in on toggle
        } else {
          this.clubPrefNews = false
          this.clubPrefTickets = false
          this.clubPrefRetail = false

          // Only turn off channels if partner opt in is also associated as false/null
          if (this.partnerOptIn !== true) {
            this.emailOptIn = false
            this.directmailOptIn = false
            this.smsOptIn = false
          }
        }

      }
    },
    clubPrefNews: function (val, oldVal) {
      if (oldVal !== null) {
        this.manageChannels()
      }
    },
    clubPrefTickets: function (val, oldVal) {
      if (oldVal !== null) {
        this.manageChannels()
      }
    },
    clubPrefRetail: function (val, oldVal) {
      if (oldVal !== null) {
        this.manageChannels()
      }
    },
    partnerOptIn: function (val, oldVal) {
      if (oldVal !== null) {
        this.manageChannels()
      }
    },
    emailOptIn: function (val, oldVal) {
      if (oldVal !== null) {
        this.manageChannels()
      }
    },
    smsOptIn: function (val, oldVal) {
      if (oldVal !== null) {
        this.manageChannels()
      }
    },
    directmailOptIn: function (val, oldVal) {
      if (oldVal !== null) {
        this.manageChannels()
      }
    }
  },
  methods: {
    enableChannels() {
      this.emailOptIn = true
      this.directmailOptIn = true
      this.smsOptIn = true
    },
    disableChannels() {
      console.log('disableChannels')
      this.emailOptIn = false
      this.directmailOptIn = false
      this.smsOptIn = false
    },
    manageChannels() {

      // If any club prefs are true, set clubAnyPrefsOptIn to true
      if (this.clubPrefTickets === true || this.clubPrefNews === true || this.clubPrefRetail === true) {
        this.clubAnyPrefsOptIn = true
      } else {
        // If any club prefs are false, set clubOptIn to false
        if (this.clubPrefTickets === false || this.clubPrefNews === false || this.clubPrefRetail === false) {
          this.clubOptIn = false
        }
        this.clubAnyPrefsOptIn = false
      }

      // If all club prefs are false and partner opt in is false, disable channels
      if (this.clubPrefTickets === false && this.clubPrefNews === false && this.clubPrefRetail === false && this.partnerOptIn === false) {
        this.disableChannels()
      }

      if ((this.clubPrefTickets === true || this.clubPrefNews === true || this.clubPrefRetail === true || this.partnerOptIn === true) && (this.emailOptIn === false && this.smsOptIn === false && this.directmailOptIn === false)) {
        this.success = null
        this.valid = false
        this.error = { 'message': 'If you have opted into communication, you must select at least one channel.' }
      } else {
        this.error = null
        this.valid = true
      }

    },
    crmXCMPush(username) {
      var crmXCMPushURL = process.env.VUE_APP_XCM_CRM_API + '/user/push/' + username
      return axios({
        method: 'get',
        url: crmXCMPushURL
      })
    },
    complete(username) {
      var vm = this
      this.dataPush(username)
        .then(function (results) {
          vm.error = null
          var response = { "message": 'Your contact preferences have been updated successfully.' }
          vm.success = response
          vm.ready = true
        });
    },
    updateUser(e) {
      e.preventDefault()
      this.ready = false

      if (this.clubPrefTickets.toString() === 'true' || this.clubPrefNews.toString() === 'true' || this.clubPrefRetail.toString() === 'true') {
        this.clubAnyPrefsOptIn = true
      } else {
        this.clubAnyPrefsOptIn = false
      }

      var attributesList = {
        // 
        "custom:club_email": (this.clubAnyPrefsOptIn && this.emailOptIn).toString(),
        "custom:club_sms": (this.clubAnyPrefsOptIn && this.smsOptIn).toString(),
        "custom:club_direct": (this.clubAnyPrefsOptIn && this.directmailOptIn).toString(),

        "custom:partner_email": (this.partnerOptIn && this.emailOptIn).toString(),
        "custom:partner_sms": (this.partnerOptIn && this.smsOptIn).toString(),
        "custom:partner_direct": (this.partnerOptIn && this.directmailOptIn).toString(),

        "custom:club_pref_news": this.clubPrefNews.toString(),
        "custom:club_pref_tickets": this.clubPrefTickets.toString(),
        "custom:club_pref_retail": this.clubPrefRetail.toString(),

        "custom:foundation_email": this.foundationEmail.toString()
      }

      var vm = this
      this.$updateAttributes(attributesList).subscribe((response) => {
        vm.complete(this.ssoid)
      },
        (err) => {
          //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
          vm.success = null
          vm.error = err
          vm.ready = true
        });
    }
  }
}
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #EEEEEE;
}

.club-prefs {
  margin-top: 20px;
  padding: 20px;
  border: 1px solid #EEEEEE;
  /* Using hex as $core-light-grey might not be available in scoped style without import */
}
</style>